WiseMetering.Collection.Circuits = WiseMetering.Collection.extend({
    hasOrganization: true,
    model: WiseMetering.Model.Circuit,
    url: '/circuits'
});
